import { useForm } from "../../../hooks/useForm";
import { useGetUserIncentivesAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import { FETCH_SIZE } from "../../../utilities/constants";
import { formatDate } from "../../../utilities/format";
import { getTotalPages } from "../../../utilities/pagination";
import Table from "../../common/components/Table";
import { SharedIncentiveComponentProps } from "../containers/IncentiveDashboardContainer";

export default function IncentiveTable({
  period,
  filters,
}: SharedIncentiveComponentProps) {
  const { year, month } = period;
  const { userId, searchType } = filters;

  const isCaregiverSearch = searchType === "caregivers";

  const [paginationValues, onChange] = useForm({
    page: 1,
    limit: FETCH_SIZE,
  });

  const { data, loading } = useGetUserIncentivesAsAdminQuery({
    variables: {
      year,
      month,
      page: paginationValues.page,
      limit: paginationValues.limit,
      caregiverId: isCaregiverSearch && userId ? userId : null,
      guardianId: !isCaregiverSearch && userId ? userId : null,
    },
  });

  const incentives = data?.getUserIncentivesAsAdmin.edges || [];
  const pageInfo = data?.getUserIncentivesAsAdmin.pageInfo;
  const totalPages = getTotalPages(pageInfo?.totalCount, FETCH_SIZE);

  return (
    <div className="flex h-[800px] min-h-[800px] flex-col gap-3">
      <p className="text-lg font-bold">
        {year}년 {month}월 {filters.query ? `${filters.query}님` : ""} 지급 내역
      </p>
      <Table.Wrapper>
        <Table.Header
          tabs={[
            { label: "지급일" },
            { label: "사용자 이름" },
            { label: "닉네임" },
            { label: "실적 내용" },
            { label: "지급액" },
          ]}
        />
        <Table.Body isLoading={loading} isEmpty={!incentives.length}>
          {incentives.map((incentive) => {
            const user = incentive?.caregiver || incentive?.guardian;

            return (
              <Table.Row>
                <Table.Column>
                  {formatDate(incentive.createdAt, "YY년 MM월 DD일 HH:mm")}
                </Table.Column>
                <Table.Column>
                  {user?.name} {!!incentive?.caregiver ? "보호사" : "보호자"}
                </Table.Column>
                <Table.Column>{user?.username}</Table.Column>
                <Table.Column>
                  {incentive?.pointTransactionType?.name}
                </Table.Column>
                <Table.Column>
                  {incentive.amount.toLocaleString()}원
                </Table.Column>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Wrapper>
      <Table.Pagination
        page={paginationValues.page}
        total={totalPages}
        onPageChange={(newPage) => onChange("page", newPage)}
      />
    </div>
  );
}
